import { gql } from "@outschool/ui-apollo";

export const MARK_LEARNER_COMMENT_THREADS_AS_READ_MUTATION = gql`
  mutation MarkLearnerCommentThreadsAsRead(
    $input: MarkLearnerCommentThreadsAsReadInput!
  ) {
    markLearnerCommentThreadsAsRead(input: $input) {
      uid
      learnerUnreadFeedbackAssignmentClassPostUids
    }
  }
`;
